import './app/shared/chartjs-register';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

import { isDevMode } from '@angular/core';
import { addIcons } from 'ionicons';
import { 
  alertCircleOutline,
  arrowBackCircleOutline,
  buildOutline,
  businessOutline,
  chevronDownOutline,
  chevronUpOutline,
  checkmarkCircleOutline,
  checkmarkOutline,
  checkmark,
  eyeOffOutline,
  eyeOutline,
  pause,
  shieldOutline
} from 'ionicons/icons';

// FontAwesome Icons Setup
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faUserAstronaut, faRobot, faPaw, faLeaf, faSun, faHeart, 
  faBasketball, faMusic, faMountain, faFish, faCar, faMugSaucer, 
  faUser, faTrophy, faChevronDown, faChevronUp, faEye, faEyeSlash,
  faBars, faSignOutAlt, faHistory, faChartBar, faTimes,
  faPause, faChartPie, faListAlt, faCircleQuestion, faRightFromBracket, 
  faAward, faGear, faStar, faHome, faDumbbell, faCalendarDay, 
  faChartLine, faFire, faScroll, faCalendarCheck, faSpa, faCompass, 
  faBrain, faMedal, faPersonRunning, faClock, faThumbsUp, faRocket,
  faChevronLeft, faChevronRight, faInfoCircle, faCircleExclamation,
  faCheck, faBuilding
} from '@fortawesome/free-solid-svg-icons';

// Add all icons to the global library
library.add(
  faUserAstronaut, faRobot, faPaw, faLeaf, faSun, faHeart,
  faBasketball, faMusic, faMountain, faFish, faCar, faMugSaucer,
  faUser, faTrophy, faChevronDown, faChevronUp, faEye, faEyeSlash,
  faBars, faSignOutAlt, faHistory, faChartBar, faTimes,
  faPause, faChartPie, faListAlt, faCircleQuestion, faRightFromBracket, 
  faAward, faGear, faStar, faHome, faDumbbell, faCalendarDay, 
  faChartLine, faFire, faScroll, faCalendarCheck, faSpa, faCompass, 
  faBrain, faMedal, faPersonRunning, faClock, faThumbsUp, faRocket,
  faChevronLeft, faChevronRight, faInfoCircle, faCircleExclamation,
  faCheck, faBuilding
);

addIcons({
  'alert-circle-outline': alertCircleOutline,
  'arrow-back-circle-outline': arrowBackCircleOutline,
  'build-outline': buildOutline,
  'business-outline': businessOutline,
  'chevron-down-outline': chevronDownOutline,
  'chevron-up-outline': chevronUpOutline,
  'checkmark-circle-outline': checkmarkCircleOutline,
  'checkmark-outline': checkmarkOutline,
  'checkmark': checkmark,
  'eye-outline': eyeOutline,
  'eye-off-outline': eyeOffOutline,
  'pause': pause,
  'shield-outline': shieldOutline,
});

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
